import { render, staticRenderFns } from "./Disease.vue?vue&type=template&id=f67eb12e&scoped=true&"
import script from "./Disease.vue?vue&type=script&lang=js&"
export * from "./Disease.vue?vue&type=script&lang=js&"
import style0 from "./index.less?vue&type=style&index=0&id=f67eb12e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67eb12e",
  null
  
)

export default component.exports